import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const HeroSection = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-br from-background via-primary to-secondary">
      {/* Animated Background Elements */}
      <div className="absolute inset-0 neural-network-bg">
        <div className="absolute top-20 left-10 w-2 h-2 bg-accent rounded-full animate-pulse"></div>
        <div className="absolute top-40 right-20 w-1 h-1 bg-cyber-purple rounded-full animate-pulse-slow"></div>
        <div className="absolute bottom-32 left-1/4 w-1.5 h-1.5 bg-success rounded-full animate-bounce-slow"></div>
        <div className="absolute bottom-20 right-1/3 w-1 h-1 bg-warning rounded-full animate-pulse"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <div className="text-center lg:text-left">
            <div className="inline-flex items-center px-4 py-2 rounded-full bg-accent/10 border border-accent/20 mb-6">
              <Icon name="Sparkles" size={16} className="text-accent mr-2" />
              <span className="text-sm font-medium text-accent">Established 2015</span>
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-foreground mb-6 leading-tight">
              Where Dreams Meet{' '}
              <span className="gradient-text">Code</span>
            </h1>

            <p className="text-xl text-muted-foreground mb-8 max-w-2xl">
              We're not just another coding bootcamp. We're a community-driven movement that transforms passionate learners into tomorrow's technology leaders through AI, Robotics, and Advanced Programming.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start mb-12">
              {/* <Button
                variant="default"
                size="lg"
                className="morphing-cta text-white font-semibold"
                iconName="ArrowRight"
                iconPosition="right"
              >
                Our Story
              </Button>
              <Button
                variant="outline"
                size="lg"
                iconName="Play"
                iconPosition="left"
              >
                Watch Vision Video
              </Button> */}
            </div>

            {/* Quick Stats */}
            <div className="grid grid-cols-3 gap-6 pt-8 border-t border-border">
              <div className="text-center lg:text-left">
                <div className="text-2xl font-bold text-accent">10,000+</div>
                <div className="text-sm text-muted-foreground">Students Transformed</div>
              </div>
              <div className="text-center lg:text-left">
                <div className="text-2xl font-bold text-success">5000+</div>
                <div className="text-sm text-muted-foreground">Projects Developed</div>
              </div>
              <div className="text-center lg:text-left">
                <div className="text-2xl font-bold text-cyber-purple">10+</div>
                <div className="text-sm text-muted-foreground">Partner Companies</div>
              </div>
            </div>
          </div>

          {/* Visual */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-elevated">
              <Image
                src="https://images.unsplash.com/photo-1522202176988-66273c2fd55f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
                alt="Dream Coders Club community learning session"
                className="w-full h-96 object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background/80 via-transparent to-transparent"></div>
              
              {/* Floating Elements */}
              <div className="absolute top-4 right-4 bg-card/90 backdrop-blur-sm rounded-lg p-3 border border-border">
                <div className="flex items-center space-x-2">
                  <div className="w-2 h-2 bg-success rounded-full animate-pulse"></div>
                  <span className="text-xs font-medium text-foreground">Live Session</span>
                </div>
              </div>
              
              <div className="absolute bottom-4 left-4 bg-card/90 backdrop-blur-sm rounded-lg p-3 border border-border">
                <div className="flex items-center space-x-2">
                  <Icon name="Users" size={16} className="text-accent" />
                  <span className="text-sm font-medium text-foreground">24 Active Learners</span>
                </div>
              </div>
            </div>

            {/* Decorative Elements */}
            <div className="absolute -top-4 -right-4 w-20 h-20 bg-gradient-to-br from-accent to-cyber-purple rounded-full opacity-20 blur-xl"></div>
            <div className="absolute -bottom-4 -left-4 w-16 h-16 bg-gradient-to-br from-success to-warning rounded-full opacity-20 blur-xl"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;